module.exports = __webpack_public_path__ + "static/img/logo-hexagon-white.cd43f380.svg";